<template>
    <div class="resourceServiceDirectorySearch">
        <Row :gutter="10">
            <Col span="5">
                <Input search v-model="usageNote" :placeholder="$t('resourceLifecycle.queryByPurpose')" @on-search="searchUsageNote()"/>
            </Col>
            <Col span="5">
                <Input search v-model="resourceName" :placeholder="$t('resourceLifecycle.queryByResourceName')" @on-search="searchResourceName()"/>
            </Col>
            <Col span="5">
                <Select v-model="resourceType" filterable :placeholder="$t('resourceLifecycle.filterByResourceType')" :transfer="true" @on-change="searchLifecycleResourcesDate()">
                    <Option :value="item.id" v-for="item in resourceTypeList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="6">
                <Button type="primary" @click="addResource()">{{$t('resourceLifecycle.addResource')}}</Button>
            </Col>
        </Row>
    </div>
</template>
<script>
    import TableResourceServiceDirectory from '../resource_service_directory/TableResourceServiceDirectory'
    var tableResourceServiceDirectory = TableResourceServiceDirectory;
    export default {
        name: 'ResourceServiceDirectorySearch',
        data () {
            return {
                usageNote: '',
                resourceName: '',
                resourceType: -1,
                resourceTypeList: [{
                    id: 0,
                    name: this.$t("resourceLifecycle.virtualMachine")
                }, {
                    id: 1,
                    name: this.$t("resourceLifecycle.virtualNetwork")
                }, {
                    id: 2,
                    name: this.$t("resourceLifecycle.objectStorage")
                }, {
                    id: 3,
                    name: this.$t("resourceLifecycle.database")
                }, {
                    id: 4,
                    name: this.$t("resourceLifecycle.elasticIP")
                }, {
                    id: 5,
                    name: this.$t("resourceLifecycle.azureMySQLServer")
                }, {
                    id: 6,
                    name: this.$t("resourceLifecycle.azureMariaDBServer")
                }, {
                    id: 7,
                    name: this.$t("resourceLifecycle.azureRedisServer")
                }]
            }
        },
        methods: {
            searchUsageNote: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('usageNote', this.usageNote);
                tableResourceServiceDirectory.methods.showAll();
            },
            searchResourceName: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('resourceName', this.resourceName);
                tableResourceServiceDirectory.methods.showAll();
            },
            searchLifecycleResourcesDate: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('resourceType', this.resourceType);
                tableResourceServiceDirectory.methods.showAll();
            },
            // 添加资源
            addResource:function(){
                this.$router.push({path: '/resourceLifecycleManagement/resourceApplication', query: {t: Date.now()}});
            }
        }
    }
</script>
<style scoped>
    .resourceServiceDirectorySearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_service_directory/ResourceServiceDirectorySearch.vue